/**
 * Section header used across the district detail page.
 * Replaces the flat `text-sm font-semibold text-gray-900 mb-3` pattern
 * with a more premium two-part header: a small eyebrow category label
 * and a bolder section title, separated from content by a hairline rule.
 */
import type { ReactNode } from "react";

interface Props {
  title: string;
  /** Optional icon rendered to the left of the title. */
  icon?: ReactNode;
  /** Optional right-side element (e.g. a toggle or pill). */
  aside?: ReactNode;
}

export default function SectionHeader({ title, icon, aside }: Props) {
  return (
    <div className="flex items-center justify-between gap-3 mb-4">
      {/* The tinted icon square was dropped 2026-09-16 (owner): the title
          carries the section on its own. `icon` stays in the props so
          call sites keep compiling; it is intentionally not rendered. */}
      <h2 className="text-base font-bold text-gray-900 leading-none">
        {title}
      </h2>
      {aside && <div className="shrink-0">{aside}</div>}
    </div>
  );
}
